<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">挂号信息</div>
				<div class="titleR"></div>
			</div>
			<div class="content">
				<div class="L">
					<div class="label">接诊状态</div>
					<div class="label" v-if="!$public.isNull(curBingli)&&!$public.isNull($public.getMatchingItem(bingliList,'caseNumber',curBingli).diagnosisTags)" style="padding:0 0 0 250px;">
						<div v-for="(item1,index1) in $public.getMatchingItem(bingliList,'caseNumber',curBingli).diagnosisTags" :key="index1">
							<span v-for="(item2,index2) in item1.symptom" :key="index2">
								{{item1.value}}-{{item2.value}}-{{item2.symptomLevel[0].value}} 
							</span>
						</div>
					</div>
					<el-radio-group v-model="isTransfer" @change="changeIsTransfer" style="width:250px;padding-bottom:20px;padding-top:5px;">
						<el-radio :label="1">初诊</el-radio>
						<el-radio :label="2">复诊</el-radio>
						<el-radio :label="3">转诊</el-radio>
					</el-radio-group>
					<div v-if="isTransfer!==1" style="display: inline-block;padding-bottom:20px;padding-top:5px;vertical-align: middle;font-size: 14px;color:#73737B;">
						病例信息：
						<el-select v-if="!$public.isNull(bingliList)" v-model="curBingli" @change="changeCurBingli" :disabled="$public.isNull(curPetInfo._id)" filterable placeholder="请选择" size="mini" style="width:180px;">
							<el-option v-for="item in bingliList" :key="item.caseNumber" :label="item.caseNumber"
							:value="item.caseNumber"></el-option>
						</el-select>
						<span v-else>无过往病例</span>
					</div>
					<div class="label">销售人员</div>
					<el-select v-model="handlerId" @change="changeHandlerId" multiple filterable placeholder="请选择" size="mini" style="width:180px;">
						<el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
						:value="item._id+','+item.basic_info.nick_name"></el-option>
					</el-select>
					<div class="label" style="padding-top:20px;">值班医生</div>
					<div class="xmjBox">
						<div class="xmjItem" :class="doctor.split(',')[0]===item.userId?'active':''" @click="changeDoctor(item)" v-for="(item) in doctorList" :key="item.userId">
							{{item.userName}}
						</div>
					</div>
					<div class="label">科室</div>
					<div class="xmjBox">
						<div class="xmjItem" :class="department.split(',')[0]===item._id?'active':''" @click="changeDepartment(item)"  v-for="(item) in departmentList" :key="item._id">
							{{item.name}}
						</div>
					</div>
				</div>
				<div class="R">
					<div v-for="(serviceItem,serviceIndex) in serviceList" :key="serviceIndex">
						<div v-if="!$public.isNull(serviceItem.serviceId)">
							<div style="font-size: 14px;padding: 10px 30px 0px;">
								{{serviceItem.title}}
							</div>
							<div class="roomBox">
								<div class="room" :class="[goodsId===skuItem.service_objectId?'active':'']" @click="changeService(serviceItem,skuItem)" v-for="(skuItem,skuIndex) in serviceItem.serviceItems" :key="skuIndex">
									<div class="roomName">{{skuItem.service_objectName}}</div>
									<div class="roomPrice">￥{{skuItem.price}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="settlement">
			<div class="settlementL"></div>
			<div class="settlementR">
				<div class="text" >
					应付金额：
					<span style="color:#F5882A;font-size: 18px;">￥{{price}}</span>
				</div>
				<el-button type="warning" size="small" plain @click="payMode='GH';submitOrder()">挂号</el-button>
				<el-button type="warning" size="small" @click="payMode='GHandJZ';submitOrder()">挂号并接诊</el-button>
			</div>
		</div>
		<!-- 结算 -->
		<div v-if="dialogSettlement_state">
			<dialogSettlement :type="'order'" :orderId="curOrder._id" @submit="submit_dialogSettlement"></dialogSettlement>
		</div>
	</div>
</template>
<script>
	import dialogSettlement from "../../../../components/dialog_settlement.vue"
	export default {
		components:{dialogSettlement},
		data(){
			return{
				// 转诊
				isTransfer:1,
				// 经办人
				handlerId:'',
				staffList:[],
				//医生
				doctor:'',
				doctorList:[],
				//科室
				department:'',
				departmentList:[],
				// 诊室
				room:'',
				roomList:[],
				// 挂号服务
				price:0,
				goodsId:'',
				serviceItem:{},
				skuItem:{},
				serviceList:[],
				// 结算
				payMode:'GH',
				dialogSettlement_state:false,
				curOrder:{},
				// 过往病例
				curBingli:'',
				bingliList:[],
				
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
			jiezhenParams(){
				return this.$store.state.yiliaoxin.jiezhenParams;
			},
		},
		watch:{
			userInfo(){
				this.isTransfer = 1
				this.curBingli = ''
				this.getBingliList()
			}
		},
		mounted(){
			this.getStaffList();
			this.getDoctorList();
			this.getKeshiList();
			this.getServiceList();
			this.getBingliList()
			this.$store.state.yiliaoxin.userController.map((controller)=>{
				if(controller.invitationType===3&&controller.userId.length>0){
					this.handlerId = [controller.userId+","+controller.userName]
				}
			})
		},
		methods: {
			// 创建订单
			submitOrder(){
				if(this.$public.isNull(this.userInfo._id)){
					this.$message({
						message: '请选择顾客',
						type: 'error'
					});
					return ;
				}
				if(this.$public.isNull(this.curPetInfo._id)){
					this.$message({
						message: '请选择宠物',
						type: 'error'
					});
					return ;
				}
				if(this.$public.isNull(this.skuItem.service_objectId)){
					this.$message({
						message: '请选择挂号服务',
						type: 'error'
					});
					return ;
				}
				if(this.isTransfer!==1){
					if(this.$public.isNull(this.curBingli)){
						this.$message({
							message: '复诊或转诊必须关联病例编号',
							type: 'error'
						});
						return ;
					}
				}
				let salesMans = []
				if(Number(this.price)!==0){
					if(this.$public.isNull(this.handlerId)){
						this.$message({
							message: '请选择销售人员',
							type: 'error'
						});
						return ;
					}
					for(let i=0;i<this.handlerId.length;i++){
						let arr = this.handlerId[i].split(',')
						salesMans.push({"userId": arr[0],"userName": arr[1]})
					}
				}
				let params = {
					"departmentId": this.department.split(',')[0], 
					"departmentName": this.department.split(',')[1],
					"memberId": this.userInfo._id,
					"memberName": this.userInfo.basic_info.nick_name,
					"memberMobile": this.userInfo.basic_info.user_mobile,
					"petId": this.curPetInfo._id,
					"petName": this.curPetInfo.nick_name,
					"classType": this.curPetInfo.apply_type.value,
					"className": this.curPetInfo.apply_type.title,
					"typeName": this.curPetInfo.category_info.name, // 宠物种类
					"sex": this.curPetInfo.pet_sex,
					"birthDay": this.curPetInfo.bron_date,
					"doctorId": this.doctor.split(',')[0],
					"doctorName": this.doctor.split(',')[1],
					"remark": '',
					registrationType: this.isTransfer,  // 挂号类型 1初诊；2复诊；3转诊
					linkCaseNumber:this.curBingli,  // 复诊以及转诊所关联的病例编号
					// "roomId": this.room.split(',')[0],
					// "roomName": this.room.split(',')[1]||'',
					"serviceId": this.serviceItem.serviceId,
					"serviceName": this.serviceItem.title,
					"serviceObjectId": this.skuItem.service_objectId,
					"serviceObjectName": this.skuItem.service_objectName,
					"categoryId": this.serviceItem.category_info._id,
					"categoryName":this.serviceItem.category_info.name,
					"salesMans": salesMans,
				}
				console.log(params)
				let loading = this.$loading()
				this.$http.post('/api/Registration/Insert', params).then(res => {
					loading.close();
					if (res.code == 0) {
						if(Number(this.price)!==0){
							this.curOrder = res.data;
							this.dialogSettlement_state = true;
						}else{
							this.$message({
								message: '挂号成功',
								type:'success'
							});
							let obj = this.jiezhenParams
							obj.type = "list"
							this.$store.commit("yiliaoxin/set_jiezhenParams",obj)
							this.$store.commit("yiliaoxin/set_curBusiness",'接诊')
							this.$store.dispatch("yiliaoxin/get_NotMedicalCount")
							this.$store.dispatch("yiliaoxin/get_danganNumber",this.curPetInfo._id||'')
							// if(this.payMode==='GHandJZ'){
							// 	this.$store.commit("setCurNavIndex_yiliao",{title:'接诊',path:'/yiliao/guahaoList'})
							// 	this.$router.push({path:"/yiliao/guahaoList",query:{tabIndex:1}})
							// }else if(this.payMode==="GH"){
							// 	this.userId = ''
							// 	this.userInfo = {basic_info:{},card_info:{}}
							// 	this.petId = ''
							// 	this.petItem = {}
							// 	this.isTransfer = false
							// 	this.handlerId = ''
							// 	this.doctor = ''
							// 	this.department = ''
							// 	this.room = ''
							// 	this.price = 0
							// 	this.goodsId = ''
							// 	this.serviceItem = {}
							// 	this.skuItem = {}
							// 	this.curOrder = {}
							// 	this.payMode = ''
							// }
						}
					}
				})
			},
			submit_dialogSettlement(a){
				this.dialogSettlement_state = false;
				if(a=='cancel'){
					console.log(a)
				}else if(a=='fail'){
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				}else if(a=='success'){
					this.$message({
						message: '结算成功',
						type: 'success'
					});
					this.$store.dispatch("yiliaoxin/get_NotMedicalCount")
					// if(this.payMode==='GHandJZ'){
					// 	this.$store.commit("setCurNavIndex_yiliao",{title:'接诊',path:'/yiliao/guahaoList'})
					// 	this.$router.push({path:"/yiliao/guahaoList",query:{tabIndex:1}})
					// }else if(this.payMode==="GH"){
					// 	this.userId = ''
					// 	this.userInfo = {basic_info:{},card_info:{}}
					// 	this.petId = ''
					// 	this.petItem = {}
					// 	this.isTransfer = false
					// 	this.handlerId = ''
					// 	this.doctor = ''
					// 	this.department = ''
					// 	this.room = ''
					// 	this.price = 0
					// 	this.goodsId = ''
					// 	this.serviceItem = {}
					// 	this.skuItem = {}
					// 	this.curOrder = {}
					// 	this.payMode = ''
					// }
				}
			},
			// 服务
			changeService(serviceItem,skuItem){
				this.goodsId = skuItem.service_objectId
				this.price = skuItem.price;
				this.serviceItem = serviceItem;
				this.skuItem = skuItem;
			},
			getServiceList() {
				let params = {
					"keyword": "",
					"applytype": '0', // 应用分类 0:通用 1:猫 2:犬
					"categoryId": "",  // 分类编号
					"categoryCode": "register", // 分类编码handle(处置) operation(手术) detection(检查) ward(病房) register(挂号)
					"pageIndex": 1,
					"pageSize": 500
				}
				let loading = this.$loading()
				this.$http.post('/api/Product/ProductMedical/SimpleList', params).then(res => {
					loading.close()
					if (res.code == 0) {
						let list = res.data.data
						let arr = [{},{},{},{},{},{},{}]
						for(let i=0;i<list.length;i++){
							if(list[i].category_info._id==='601d11d0a93f55b5cf3ae302'){ // 普通
								arr[0]=list[i]
							}else if(list[i].category_info._id==='6055672e99455dafa9f06586'){ // 专科
								arr[1]=list[i]
							}else if(list[i].category_info._id==='601d11d0a93f55b5cf3ae304'){ // 专家
								arr[2]=list[i]
							}else if(list[i].category_info._id==='60546a14b77fa2681ea3708a'){ // 复诊
								arr[3]=list[i]
							}else if(list[i].category_info._id==='60545dd2341ae9ae311cf679'){ // 夜诊
								arr[4]=list[i]
							}else if(list[i].category_info._id==='60546be90b69e10e27f8e6ca'){ // 会诊
								arr[5]=list[i]
							}else if(list[i].category_info._id==='60545f5f341ae9ae311cfd53'){ // 出诊
								arr[6]=list[i]
							}
						}
						this.serviceList = arr;
					}
				})
			},
			// 改变转诊
			changeIsTransfer(){
				this.curBingli = ''
				console.log(this.isTransfer)
			},
			// 修改当前病例
			changeCurBingli(caseNumber){
				console.log(caseNumber)
			},
			// 销售人员
			changeHandlerId(){
				console.log(this.handlerId)
			},
			getStaffList() {
				let params = {
					"keyword": '',
					"pageIndex": 1,
					"pageSize": 500,
				}
				this.$http.get('/api/Staff/MedicalStaffList', params).then(res => {
					if (res.code == 0) {
						this.staffList = res.data.data;
					}
				})
			},
			// 值班医生
			changeDoctor(item){
				let doctor = item.userId+','+item.userName
				if(this.doctor === doctor&&this.doctor!==''){
					this.doctor = ''
				}else{
					this.doctor = doctor
				}
			},
			getDoctorList() {
				let params = {
					"date": '', // 10位时间戳
				}
				this.$http.get('/api/Registration/DutyForDay', params).then(res => {
					if (res.code == 0) {
						this.doctorList = res.data;
						console.log(this.doctorList)
					}
				})
				// this.$util.getDoctorList().then(res=>{
				// 	console.log(res)
				// })
			},
			// 科室
			changeDepartment(item){
				let department = item._id+','+item.name
				if(this.department === department&&this.department!==''){
					this.department = ''
				}else{
					this.department = department
				}
			},
			getKeshiList(){
				let loading = this.$loading()
				this.$http.get('/api/Registration/Department/List', {}).then(res => {
					loading.close()
					if (res.code == 0) {
						this.departmentList = res.data;
					}
				})
			},
			// 获取当前用户的过往病例
			getBingliList(){
				if(this.$public.isNull(this.userInfo._id)){
					return
				}
				let params = {
					memberId:this.userInfo._id,
					"departmentId": '',
					"petId": "", 
					isPay:-1, // -1不限；0未支付；1已支付
					isInspect:-1,  // -1不限；0未检测；1已检测
					isVisit:-1,  // -1不限；0未回访；1已回访
					isEnter:-1,  
					showLater:false,
					"desc": true, // true  倒序  false 正序
					"begin_time": "",
					"end_time": "",
					"pageIndex": 1,
					"pageSize": 500,
					"keyword": '',
				}
				let loading=this.$loading();
				this.$http.post('/api/Case/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.bingliList = res.data.data;
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;padding-bottom:68px;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;
				}
			}
			.content{
				display: flex;padding:23px 18px 23px 18px;width:100%;height: calc(100% - 47px);box-sizing: border-box;
				.L{
					width:50%;border-right: 1px solid #F2F2F2;flex-shrink: 0;box-sizing: border-box;overflow: auto;
					&::-webkit-scrollbar {
						width: 4px;
						// height: 4px;
					}
					.label{
						font-size: 14px;padding-bottom:16px;color:$fontColor;
					}
					.xmjBox{
						display: flex;justify-content: flex-start;padding:10px 0px 10px;flex-wrap: wrap;
						.xmjItem{
							position: relative;width:92px;box-sizing: border-box;line-height: 30px;text-align: center;border:1px solid #F7F8FA;font-size: 14px;cursor: pointer;margin-bottom: 16px;margin-right: 16px;border-radius: 16px;background-color: #F7F8FA;
							&.active{
								background-color: #FFF9F3;border-color:$mainColor;color:$mainColor;
							}
						}
					}
				}
				.R{
					width:50%;height: 100%;overflow: auto;
					&::-webkit-scrollbar {
						width: 4px;
						// height: 4px;
					}
					.col{
						display: flex;
						align-items: center;
						padding-bottom:15px;
						.RLabel{
							font-size: 14px;
							color:#6E6E6E;
							text-align: right;
							line-height: 28px;
						}
					}
					.roomBox{
						display: flex;padding:10px 70px 10px 100px;flex-wrap: wrap;
						.room{
							position: relative;width:140px;height: 86px;border:1px solid #F7F8FA;box-sizing: border-box;background-color: #F7F8FA;margin:10px 20px;text-align: center;cursor: pointer;border-radius: 6px;;
							.mask{
								position: absolute;top:-2px;left:-2px;z-index: 10;width:210px;height: 110px;background-color: rgba(0,0,0,.5);
							}
							.tip{
								position: absolute;top:-2px;left:-2px;width:55px;height: 20px;text-align: center;color:#fff;background-color: #FFAE11;font-size: 12px;line-height: 20px;
							}
							.checked{
								position: absolute;right:-2px;bottom:-2px;width:40px;height: 18px;text-align: center;color:#fff;
							}
							.roomName{
								font-size: 16px;color:$fontColor;padding-top:25px;font-weight: bold;
							}
							.roomPrice{
								font-size: 12px;color:$fontColor;padding-top:10px;
							}
							&.active{
								background-color: #FFF9F3;border-color:$mainColor;color:$mainColor;
								.roomName{
									color:$mainColor;
								}
								.roomPrice{
									color:$mainColor;
								}
							}
						}
					}
				}
			}
		}
		.settlement{
			position: absolute;bottom:0;width:100%;height:56px;background-color: #fff;border-radius: 12px 12px 0 0;display: flex;padding:12px 20px;box-sizing: border-box;
			.settlementL{
				width:50%;
			}
			.settlementR{
				width:50%;text-align: right;
				.text{
					color:$fontColor;font-size: 14px;padding:0px 24px 0;display: inline-block;margin-right: 20px;
				}
			}
			
		}
	}
</style>
